"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
const defaultProps = {
  slots: {
    leftArrowIcon: _icons.ArrowLeftThin,
    rightArrowIcon: _icons.ArrowRightThin,
    switchViewIcon: _icons.ArrowDown
  }
};
var _default = exports.default = {
  defaultProps
};
//# sourceMappingURL=MuiDateCalendar.js.map